import { useQuery } from "@tanstack/react-query";
import customFieldGroupService from "../api/customFieldGroupService";

export const useCustomFieldGroupByTaskTypeId = (taskTypeId, showHidden) => {
  const { getCustomFieldGroupByTaskTypeId } = customFieldGroupService();

  return useQuery({
    queryKey: ["get-custom-field-group-by-task-type-id", taskTypeId],
    queryFn: async () => {
      const res = await getCustomFieldGroupByTaskTypeId(taskTypeId, showHidden);
      return res.data;
    },
    enabled: !!taskTypeId,
  });
};

export const useCustomFieldGroup = (id) => {
  const { getCustomFieldGroup } = customFieldGroupService();

  return useQuery({
    queryKey: ["get-custom-field-group", id],
    queryFn: async () => {
      const res = await getCustomFieldGroup(id);
      return res.data;
    },
    enabled: !!id,
  });
};
